export const event = "http://purl.org/NET/c4dm/event.owl#";
export const ical = "http://www.w3.org/2002/12/cal/ical#";
export const time = "http://www.w3.org/2006/time";
